import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import PropTypes from 'prop-types';

import { TablePagination } from '@material-ui/core';

export const CLEANING_REPORT_TASKS_TABLE_DEFAULT_ROWS_PER_PAGE = 10;

export const CLEANING_REPORT_TASKS_TABLE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50];

function CleaningReportTasksTablePagination({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions,
    intl,
}) {
    if (count === 0) {
        return null;
    }

    return (
        <TablePagination
            component="div"
            count={count}
            page={page}
            onPageChange={onPageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            labelRowsPerPage={intl.formatMessage({
                id: 'page.robots.cleaning_report.pagination.rows_per_page',
            })}
            labelDisplayedRows={({ from, to, count: rowCount }) =>
                intl.formatMessage(
                    {
                        id:
                            'page.robots.cleaning_report.pagination.displayed_rows',
                    },
                    { from, to, count: rowCount }
                )
            }
        />
    );
}

CleaningReportTasksTablePagination.propTypes = {
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onRowsPerPageChange: PropTypes.func.isRequired,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
    intl: intlShape.isRequired,
};

CleaningReportTasksTablePagination.defaultProps = {
    rowsPerPageOptions: CLEANING_REPORT_TASKS_TABLE_ROWS_PER_PAGE_OPTIONS,
};

export default injectIntl(CleaningReportTasksTablePagination);
